import {
  getDDMMMYYYYv1,
  getDDMMYYYYv1,
  getMMDDYYYYv1,
  getYYYYMMDDv1,
  getYYYYMMDDJP,
} from '../core';
import { DateFormat } from './types/enums';

const getDateText = (date: Date, dateFormat: DateFormat) => {
  const dateString = date.toDateString();
  // Passing false to skip timezone conversion and only get required date formatting
  switch (dateFormat) {
    case DateFormat.DDMMMYYYY:
      return getDDMMMYYYYv1(dateString, { convertTimeZone: false });

    case DateFormat.MMDDYYYY:
      return getMMDDYYYYv1(dateString, { convertTimeZone: false });

    case DateFormat.YYYYMMDD:
      return getYYYYMMDDv1(dateString, { convertTimeZone: false });

    case DateFormat.YYYYMMDD_JP:
      return getYYYYMMDDJP(dateString, false);

    case DateFormat.YYYYMM:
      return `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
    default:
      return getDDMMYYYYv1(dateString, { convertTimeZone: false });
  }
};
export const getDateTimeText = (
  dateFormat: DateFormat,
  scheduledDateTime?: Date,
  scheduledDateTimeTo?: Date,
  scheduledStartTime?: string,
  scheduledEndTime?: string,
  showTime?: boolean,
  selectRange?: boolean,
): string => {
  let dateTimeText = '';

  if (scheduledDateTime) {
    dateTimeText = `${getDateText(scheduledDateTime, dateFormat)} `;
    if (showTime && scheduledStartTime) {
      dateTimeText += scheduledStartTime;
    }
  }

  if (selectRange) {
    if (scheduledDateTime && scheduledDateTimeTo) {
      dateTimeText += ` to ${getDateText(scheduledDateTimeTo, dateFormat)} `;

      if (showTime && scheduledEndTime) {
        dateTimeText += scheduledEndTime;
      }
    } else {
      dateTimeText = '';
    }
  }
  return dateTimeText;
};

export const assignIfExists = <T>(value: T | undefined, setter: (v: T) => void) => {
  if (value) {
    setter(value);
  }
};
